// update state
const setFolderIdAction = (payload) => {
    return {
        type: "FOLDERID",
        payload
    }

}

export default setFolderIdAction;




// WEBPACK FOOTER //
// ./src/actions/setFolderIdAction.js